module.exports = __webpack_public_path__ + "fontawesome-webfont-v=4.4.0.7c87870ab40d63cfb887.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/font-awesome/fontawesome-webfont-v=4.4.0.ttf
// module id = 700
// module chunks = 2